module.exports = __webpack_public_path__ + "img/FIBW.b543a23a.png";